import { jQueryPostJson } from './jquery-networking';
import browser from './browser';
import forms from './forms';
import handlebarsUtils from '../common/handlebars-utils';

const confirmModalTemplate = Handlebars.compile(`
	<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal-label" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<form method="post">
					<input name="{{xsrfTokenKey}}" type="hidden" value="{{xsrfToken}}" />
					<div class="modal-header">
						<h5 class="modal-title" id="modal-label">{{modalTitle}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Cancel">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div>
							<div class="alert alert-danger server-rule-violation-summary validation-summary-valid">
								<span>The following errors occurred:</span>
								<ul><li style="display:none"></li></ul>
							</div>
							<div class="alert alert-danger server-failure-summary validation-summary-errors validation-summary-valid">
								<span>An unexpected error occurred</span>
								<p>Please try again later</p>
							</div>
						</div>
						{{> modalContent}}
						{{#if warningMessage}}
							<div class="alert alert-warning mt-2" role="alert">
								{{#if warningMessageBadge}}
									<span class="badge badge-warning">{{warningMessageBadge}}</span>
								{{/if}}
								{{{warningMessage}}}
							</div>
						{{/if}}
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary disable-on-commit" data-dismiss="modal">Cancel</button>
						<button type="button" class="btn btn-{{buttonState}} disable-on-commit">{{confirmBtnLabel}}</button>
					</div>
				</form>
			</div>
		</div>
	</div>`);

function configureConfirmActionLink (actionNode: Node | HTMLElement | JQuery<HTMLElement> | JQuery<Node>,
	data?: any, modalTargetId?: string) {
	const escapeHtml = (str: string | null) => new Option(str || '').innerHTML;

	$(actionNode).each((i, n) => {
		const $n = $(n);
		const confirmMessage = escapeHtml($n.data('commandTargetModalConfirm'));
		const warningMessage = escapeHtml($n.data('modalContentWarning')).replace(/\\n/g, '<br>');
		configureActionLink(n, confirmMessage, data, modalTargetId, undefined, warningMessage);
	});
}

function configureActionLinkFromTemplate (actionNode: JQuery<HTMLElement>,
	data?: any, modalTargetId?: string, buildPostCommand?: ($form: JQuery) => any) {
	$(actionNode).each((i, n) => {
		const $n = $(n);
		const modalContentTemplateId = $n.data('modalContentTemplateId') || '';
		const warningMessage = ($n.data('modalContentWarning') || '').replace(/\\n/g, '<br>');

		if (modalContentTemplateId === '') {
			throw new Error(`Please specify a content template selector for the ${modalTargetId} modal.`);
		}

		const modalContentTemplate = handlebarsUtils.compileTemplateFrom(modalContentTemplateId, true);

		configureActionLink(n, modalContentTemplate, data, modalTargetId, buildPostCommand, warningMessage);
	});
}

function toggleOnSubmitButtons (state: boolean, $context?: JQuery) {
	const $ctx = $context || $(document);
	const $element: JQuery<HTMLElement> =
		$ctx.find('button.disable-on-commit, .disable-on-commit button, .disable-on-commit .btn')as JQuery<HTMLElement>;

	$element.prop('disabled', state)
		.toggleClass('disabled', state);
}

function configureActionLink (actionNode: Node | HTMLElement | JQuery<HTMLElement> | JQuery<Node>,
	modalContentTemplate: Handlebars.TemplateDelegate | string, data?: any, modalTargetId?: string,
	buildPostCommand?: ($form: JQuery) => any, warningMessage?: string) {
	const $actionNode = $(actionNode);

	$actionNode.on('click', (evt: JQueryEventObject) => {
		evt.preventDefault();
		const target = evt.target as HTMLAnchorElement;

		if (modalTargetId && modalContentTemplate) {
			const $modalContainer = $(`#${modalTargetId}`);

			if ($modalContainer.length === 0) {
				throw new Error(`No modal target found with an ID of ${modalTargetId}!`);
			} else {
				$modalContainer.empty();

				const $target = $(target);
				const confirmBtnLabel = $target.data('modalConfirmButtonLabel') || 'Confirm';
				const buttonState = $target.data('buttonState') || 'primary';
				const modalTitle = $target.data('modalTitle') || $target.text();
				const warningMessageBadge = $target.data('modalContentWarningBadge' || '');

				const modalData = {
					confirmBtnLabel,
					modalTitle,
					data,
					warningMessage,
					buttonState,
					warningMessageBadge
				};

				Handlebars.registerPartial('modalContent', modalContentTemplate);
				$modalContainer.html(confirmModalTemplate(modalData));

				const $form = $modalContainer.find('form');
				const hasFields = $form.has(':input').length > 0;

				// reset validation if necessary for added content
				const validator = $.validator;
				if (hasFields && validator) {
					validator.unobtrusive.parse($form);
				}

				$modalContainer.find('.btn-primary, .btn-danger').on('click',
					(modalConfirmClickEvt: JQueryEventObject) => {
						modalConfirmClickEvt.preventDefault();

						$form.attr('action', target.href);
						const buildCommand = () => {
							const commandData = {};
							if (data) {
								Object.assign(commandData, data);
							}
							if (buildPostCommand) {
								Object.assign(commandData, buildPostCommand($form));
							}
							return commandData;
						};

						// reset buttons based on changes and validation
						$form.on('change', () => {
							const validate = $form.validate();
							if (validate) {
								const inactivateButtons = !$form.valid();
								toggleOnSubmitButtons(inactivateButtons, $modalContainer);
							}
						});

						toggleOnSubmitButtons(true, $modalContainer);

						forms.postFormCommand($form,
							buildCommand,
							(m) => {
								forms.displayServerRuleViolations(m, $modalContainer);
								toggleOnSubmitButtons(false, $modalContainer);
							},
							forms.redirectToLoginPage,
							() => {
								forms.displayServerFailure($modalContainer);
								toggleOnSubmitButtons(false, $modalContainer);
							});
					});

				$modalContainer.find('.modal').modal('show');
			}
		} else {
			const targetUrl = target.href;
			toggleOnSubmitButtons(true);

			jQueryPostJson(targetUrl, data)
				.then((resp: any) => browser.redirect(resp.redirectUrl))
				.fail((resp: any) => {
					forms.handlePostJsonFailure(resp);
					toggleOnSubmitButtons(false);
				});
		}
	});
}

export default {
	configureConfirmActionLink,
	configureActionLink,
	configureActionLinkFromTemplate
};
